import { styled } from '@abyss/web/tools/styled';
import { Accordion } from '@abyss/web/ui/Accordion';
import { Button } from '@abyss/web/ui/Button';
import { Drawer } from '@abyss/web/ui/Drawer';
import { Heading } from '@abyss/web/ui/Heading';
import { Markdown } from '@abyss/web/ui/Markdown';
import { Text } from '@abyss/web/ui/Text';
import { ToggleSwitch } from '@abyss/web/ui/ToggleSwitch';

export const StyledDrawer = styled(Drawer, {
  zIndex: '1080 !important',
  '.abyss-modal-header-container': {
    width: 'fit-content',
  },
  '.abyss-modal-content-container': {
    borderRadius: 0,
    '@screen < $xl': {
      '& .abyss-modal-body > div': {
        marginLeft: '0px',
        marginRight: '0px',
      },
    },
    '@screen < $sm': {
      top: '25px',
      height: 'calc(100vh - 26px)',
      width: '100%',
      borderRadius: '20px 20px 0px 0px',
      color: '$primary1',
      border: '1px solid $primary1',
      '& .abyss-modal-body > div': {
        marginLeft: '16px',
        marginRight: '16px',
      },
    },
  },
  '.abyss-modal-close-button': {
    zIndex: '9999 !important',
    '@screen < $sm': {
      top: '12px',
      right: '12px',
    },
  },
  '.abyss-modal-body': {
    scrollbarWidth: 'none' /* Hide scrollbar for Chrome, Safari and Opera */,
    '::-webkit-scrollbar': {
      display: 'none',
    },
  },
});

const headingStyle = {
  fontFamily: '$primary !important',
  fontWeight: '700 !important',
  fontSize: '20.25px !important',
  lineHeight: '24px !important',
  letterSpacing: '0px',
};

export const HeadingText = styled(Heading, {
  ...headingStyle,
  marginTop: '16px',
});

export const HeadingTextOnBoarding = styled('h3', {
  ...headingStyle,
  marginLeft: '4px',
});

export const DescriptionTextOnboarding = styled(Text, {
  margin: '4px 0px 16px 30px',
  fontSize: '18px',
  fontWeight: '400',
  lineHeight: '24px',
});

export const OnboardingDisclaimerText = styled(Text, {
  fontSize: '14px',
  fontWeight: '500',
  lineHeight: '14px',
  color: '#323333',
  letterSpacing: '0px',
  marginTop: '8px',
});

export const FlexContainer = styled('ul', {
  marginTop: '16px',
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row',
  listStyleType: 'none',
});

export const ToggleSwitchField = styled(ToggleSwitch, {
  padding: '4px 16px 4px 16px',
  '.abyss-toggle-switch-label': { marginLeft: '8px' },
});

export const AccordionContainer = styled(Accordion, {
  paddingLeft: '16px',
  paddingRight: '16px',
  fontFamily: '$primary',
  backgroundColor: 'transparent',
  '& .abyss-accordion-trigger': {
    color: '$gray8',
    padding: '0px',
    cursor: 'pointer',
    border: 'none',
    '&:hover': { backgroundColor: '$gray1' },
    '& .abyss-accordion-header': {
      fontWeight: '500',
      fontSize: '18px',
    },
    '& .abyss-accordion-header-subtext': {
      fontSize: '16px',
      fontWeight: '400',
      color: '$gray8',
    },
    '& .abyss-heading-root': {
      fontSize: '18px',
      fontWeight: '500',
    },
  },
  '& .abyss-radio-group-container': { marginTop: '16px' },
  '& .abyss-checkbox-group-container': {
    marginTop: '16px',
    maxHeight: '300px',
    overflow: 'auto',
  },
  '& .abyss-checkbox-flex-container': {
    margin: '4px',
  },
  '& .abyss-accordion-content-text': { padding: '0px 0px 10px 4px' },
});

export const StyledMarkdown = styled(Markdown, {
  fontSize: '18px',
  fontWeight: '400',
  lineHeight: '24px',
  color: '$gray8',
  'abyss-layout-stack': {
    paddingTop: '8px',
  },
  '.abyss-icon-symbol': {
    fontSize: '18px !important',
    paddingTop: '2px',
    color: '$interactive1 !important',
  },
  '.abyss-link-root': {
    fontSize: '14px',
    lineHeight: '18px',
    borderColor: 'white !important',
  },
  '.abyss-flex-root': {
    paddingLeft: '5px',
  },
  '.abyss-accordion-trigger': {
    border: 'none',
    padding: '0px',
  },
});

export const ClearAllButton = styled(Button, {
  background: 'transparent !important',
  border: 'none !important',
  padding: '0',
  cursor: 'pointer',
  outline: 'none',
  boxShadow: 'none',
  '&:hover': {
    background: 'transparent !important',
    border: 'none ',
    boxShadow: 'none',
  },
});
